import { render } from "./PhotoLightbox.vue?vue&type=template&id=7a0a4ed1&ts=true"
import script from "./PhotoLightbox.vue?vue&type=script&lang=ts"
export * from "./PhotoLightbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__